import { render, staticRenderFns } from "./personageAlterPassword.vue?vue&type=template&id=a36de63a&scoped=true&"
import script from "./personageAlterPassword.vue?vue&type=script&lang=js&"
export * from "./personageAlterPassword.vue?vue&type=script&lang=js&"
import style0 from "./personageAlterPassword.vue?vue&type=style&index=0&id=a36de63a&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a36de63a",
  null
  
)

export default component.exports